import { useMutation } from "@apollo/client/react";
import paths from "config/routePaths";
import { ResetSite } from "hooks/apollo/site/site.gql";
import useTimeZone from "hooks/useTimeZone";
import Authorization from "policies/Authorization";
import React, { useState } from "react";
import { useNavigate } from "react-router";
import ResetSiteView from "./ResetSiteView";

export default function ResetSiteContainer({ id }) {
  const policy = Authorization.usePolicy();
  const { overrideToSiteTimeZone } = useTimeZone();

  const navigate = useNavigate();
  const [resetSite] = useMutation(ResetSite, {
    onCompleted: () => {
      navigate(paths.home);
      navigate(0);
    },
  });
  const [isResetSiteOpen, setResetSiteOpen] = useState(false);

  const handleReset = ({ preset, relativeDate }) => {
    const confirmed = window.confirm(
      "Are you sure you want to delete existing data and create sample data? This action is irreversible.",
    );

    if (confirmed) {
      const overriddenDate = overrideToSiteTimeZone(relativeDate);

      return resetSite({
        variables: { id, preset, relativeDate: overriddenDate },
      });
    }
    return Promise.resolve();
  };

  return (
    <ResetSiteView
      canReset={policy.canReset(Authorization.EntityTypes.Site)}
      isResetSiteOpen={isResetSiteOpen}
      onReset={handleReset}
      setResetSiteOpen={setResetSiteOpen}
    />
  );
}
